import { track } from 'utils/tracking';
import { ITrackingProductPageBaseParameters } from '../shared/baseParameters';
import { fillItems, ITrackingFillItemsParameters } from '../shared/fillItems';
import {
  fillRewardCampaign,
  ITrackingFillRewardCampaignParameters,
} from '../shared/fillRewardCampaign';

export const trackProductDetailsClose = (
  parameters: {
    source: 'Close' | 'Modal Outside';
  } & Pick<ITrackingProductPageBaseParameters, 'leadId'> &
    ITrackingFillItemsParameters &
    ITrackingFillRewardCampaignParameters,
): void => {
  const { source, leadId } = parameters;

  return track({
    event: 'product_interaction',
    component_type: source === 'Close' ? 'button' : 'modal-outside',
    component_title: `Product Details Overlay_${source}`,
    action: 'close',
    item_list_name: 'apply form',
    ...fillItems(parameters),
    step_number: '1',
    step_name: 'lead-submission',
    lead_id: leadId,
    ...fillRewardCampaign(parameters),
  });
};
